import AnalysisLoading from "../../../../components/AnalysisLoading/AnalysisLoading";
import SkorDefaultLoader from "../../../../assets/img/skorDefaultLoader.gif";
import useTranslator from "../../../../hooks/useTranslator";

const ProcessingScreen = () => {
  const { _t } = useTranslator();

  return (
    <AnalysisLoading
      title={_t("analyzingYourDocument", "Analyzing your document")}
      subtitle={_t(
        "documentAnalysisUsuallyTakesUnderAMinute",
        "Usually takes under a minute. Don't close this window."
      )}
      steps={[
        _t("readingTheDocument", "Reading the document"),
        _t("checkingThePhotoIsReadable", "Checking the photo is readable"),
        _t(
          "matchingTheDetailsToYourProfile",
          "Matching the details to your profile"
        ),
      ]}
      footer={_t("dataIsEncrypted", "Data is encrypted")}
      loaderSrc={SkorDefaultLoader}
    />
  );
};

export default ProcessingScreen;
